import { useEffect, useMemo, useState } from 'react'

export const useQueryParams = <Q extends { [key: string]: string }>() => {
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [queryParams, setQueryParams] = useState<Q | null>(null)

  useEffect(() => {
    setIsLoading(false)
    setQueryParams(Object.fromEntries(new URLSearchParams(window.location.search).entries()) as Q)
  }, [])

  return useMemo<{ isLoading: true; queryParams: null } | { isLoading: false; queryParams: Q }>(
    () =>
      isLoading && typeof queryParams != 'object'
        ? {
            isLoading: true,
            queryParams: null
          }
        : {
            isLoading: false,
            queryParams: queryParams!
          },
    [isLoading, queryParams]
  )
}
